import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import riscoEspecialRepository from '@/shared/http/repositories/business/SpecialRisks'

export default {
  name: 'addRiscoEspecialApr',
  props: ['aprId', 'revisao'],
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      Adicionar: true,
      searchEpi: null,
      cancelarRiscoEspecial: false,
      dataRiscoEspecial: [],
      datanewRiscoEspecial: {},
      dataFiltroRiscoEspecial: [],
      buscaRiscoEspecial: '',
      riscoEspecialAguardandoEnvio: []
    }
  },

  watch: {
    buscaRiscoEspecial (newvalue, oldvalue) {
      if (newvalue.trim() !== '') {
        this.BuscaRiscoEspecialAdd(newvalue)
      } else {
        this.dataFiltroRiscoEspecial = this.dataRiscoEspecial
      }
    }
  },

  mounted () {
  },
  methods: {
    AdicionarRiscoEspecial (id) {
      let novaRiscoEspecial = {descricao: id.descricao, statusAprovacaoDescricao: 'AG. ENVIO', statusAprovacao: null, dateCricaoFormatada: null, dateCricao: null, riscosEspeciaisId: id.id, tipoMudanca: 'INCLUSÃO AG. ENVIO', AgEnvio: true}
      this.riscoEspecialAguardandoEnvio.push(novaRiscoEspecial)
      this.Adicionar = !this.Adicionar
      var div = document.getElementById(id.id)
      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona
      if (isClicked) {
        div.classList.remove('clicked')
        this.riscoEspecialAguardandoEnvio = this.riscoEspecialAguardandoEnvio.filter(risco => risco.riscosEspeciaisId !== id.id)
      } else {
        div.classList.add('clicked')
      }
    },
    identificarElementosClicados () {
      var elementosClicados = []
      this.dataRiscoEspecial.forEach(function (elemento) {
        var elementoHTML = document.getElementById(elemento.id)
        if (elementoHTML && elementoHTML.classList.contains('clicked')) {
          elementosClicados.push(elementoHTML.id)
        }
      })
      if (elementosClicados.length > 0) {
        this.addRiscoEspecial(elementosClicados)
      } else {
        toast.warning('Adicione pelo menos um item')
      }
    },
    cancel () {
      this.cancelar = !this.cancelarRiscoEspecial
      this.$emit('cancelarRiscoEspecial', this.cancelarRiscoEspecial)
    },
    addRiscoEspecial (ids) {
      console.log(ids)
      this.datanewRiscoEspecial = {riscosEspeciais: ids, APRId: this.aprId}
      this.$emit('salvarRiscoEspecial', this.datanewRiscoEspecial)
      this.$emit('AdicionarTableRiscoEspecial', this.riscoEspecialAguardandoEnvio)
    },
    onLoad () {
      loading.push()
      riscoEspecialRepository.GetRiscoEspecial(this.aprId, this.revisao)
        .then((Response) => {
          loading.pop()
          this.dataRiscoEspecial = Response.data.data
          this.dataFiltroRiscoEspecial = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    BuscaRiscoEspecialAdd (value) {
      this.dataFiltroRiscoEspecial = this.dataRiscoEspecial.filter((Element) => Element.descricao.toUpperCase().indexOf(value.toUpperCase()) > -1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/addSpecialRisks/addSpecialRisks.js